export default __webpack_public_path__ + "static/media/R6No2.b41a3e66.mp3";